import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .form-title {
      flex: 1;
      color: ${theme.titleColor};
      margin: 25px 0 10px 0;
      text-align: left;
      font-weight: bold;
      font-size: 20px;
    }
  `;
};
export default styles;
